export default __webpack_public_path__ + "static/bodySectionBg-54d4666824de20b99bf74c67b8ee7e8b.png";